/*
MIT LICENSE
Copyright (c) 2020-present Alibaba Cloud Design
Copied from 'antd/components/timeline/TImelineitem.tsx'.
Copyright (c) 2015-present Ant UED, https://xtech.antfin.com/

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE. */
import React from 'react';
import classNames from 'classnames';
import { ConfigContext } from '../config-provider';
import { Button } from '../button';
import { Icon } from '../icon';
import QueueAnim from 'rc-queue-anim';
const TimelineItem = ({ prefixCls: customizePrefixCls, className, color = 'gray', dot, pending = false, position /** Dead, but do not pass in <li {...omit()} */, label, title, description, footer, disabled, active, folderIndex, foldShow, children, index, toggleFold, ...restProps }) => {
    const { getPrefixCls } = React.useContext(ConfigContext);
    const prefixCls = getPrefixCls('timeline', customizePrefixCls);
    const itemClassName = classNames({
        [`${prefixCls}-item`]: true,
        [`${prefixCls}-item-pending`]: pending,
        [`${prefixCls}-item-active`]: !!active,
        [`${prefixCls}-item-disabled`]: !!disabled,
        [`${prefixCls}-item-${color}`]: true,
        [`${prefixCls}-item-custom`]: !!dot,
        [`${prefixCls}-item-folded`]: folderIndex,
        [`${prefixCls}-item-unfolded`]: foldShow
    }, className);
    const folderClassName = classNames({
        [`${prefixCls}-item-folder`]: true,
        [`${prefixCls}-item-folder-button`]: true
    });
    const dotClassName = classNames({
        [`${prefixCls}-item-head`]: true,
        [`${prefixCls}-item-head-custom`]: !!dot,
        [`${prefixCls}-item-head-${color}`]: true
    });
    const timelineNode = (React.createElement("div", { key: folderIndex },
        label && React.createElement("div", { className: `${prefixCls}-item-label` }, label),
        React.createElement("div", { className: `${prefixCls}-item-tail` }),
        React.createElement("div", { className: dotClassName, style: { borderColor: /blue|red|green|gray/.test(color || '') ? undefined : color } }, dot),
        React.createElement("div", { className: `${prefixCls}-item-content` },
            React.createElement(React.Fragment, null,
                title && React.createElement("div", { className: `${prefixCls}-item-title` }, title),
                description && React.createElement("div", { className: `${prefixCls}-item-description` }, description),
                footer && React.createElement("div", { className: `${prefixCls}-item-footer` }, footer),
                children))));
    return (React.createElement("li", { ...restProps, className: itemClassName },
        folderIndex ? (React.createElement(QueueAnim, { animConfig: [{ opacity: [1, 0] }, { opacity: [1, 0], height: 0 }] }, foldShow ? timelineNode : null)) : (timelineNode),
        folderIndex === index ? (React.createElement("div", { className: folderClassName },
            React.createElement("div", { className: dotClassName }),
            foldShow ? (React.createElement(Button, { type: 'link', size: 'small', onClick: toggleFold },
                "\u6536\u8D77",
                React.createElement(Icon, { type: 'chevron--up' }))) : (React.createElement(Button, { type: 'link', size: 'small', onClick: toggleFold },
                "\u5C55\u5F00",
                React.createElement(Icon, { type: 'chevron--down' }))))) : null));
};
// export default withConfigProvider(TimelineItem);
export default TimelineItem;
